import { render } from "./Concepts.vue?vue&type=template&id=ac1050c6"
import script from "./Concepts.vue?vue&type=script&lang=js"
export * from "./Concepts.vue?vue&type=script&lang=js"

import "./Concepts.vue?vue&type=style&index=0&id=ac1050c6&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__